var exports = {
  "A": "listItem__F7DeTb",
};

module.exports = exports;
